import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import PurchaseOrders from 'components/admin/purchase-orders/PurchaseOrders';
import BaseMenuContainer from 'components/shared/BaseMenuContainer';

export default class PurchaseOrdersContainer extends Component {
  render() {
    return (
      <BaseMenuContainer>
        <Switch>
          <Route
            exact
            path={`${this.props.match.url}/`}
            component={PurchaseOrders}
          />
        </Switch>
      </BaseMenuContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/purchase-orders/PurchaseOrdersContainer.js